module.exports = __webpack_public_path__ + "static/media/footer-arrow-icon.df19be55.svg";